import Item from "./Item";
import styles from "./index.module.less";
import data from "../../data";
const SolutionList = () => {
  return (
    <div className={styles.page}>
      {data.solutionList.map((item, index) => {
        return <Item key={index} {...item} index={index} />;
      })}
    </div>
  );
};
export default SolutionList;
